import { Palette } from '@picsart/palette';
import { memo, useCallback } from 'react';

import { presetsColors, presetColorsValues } from 'pages/Batch/configs';

import { ColorPaletteProps } from './types';

const ColorPalette = ({ isMultiRow = true, isColorPickerExist, onColorSelect, activeColor }: ColorPaletteProps) => {
  const handleColorSelect = useCallback((value: string) => {
    const idx = presetColorsValues.findIndex(x => x === value);
    onColorSelect?.(presetsColors[idx]);
  }, [onColorSelect]);

  return (
    <Palette
      isColorPickerExist={isColorPickerExist}
      onColorSelect={handleColorSelect}
      colors={presetColorsValues}
      // TODO: after automation test keep either className or dataTestId
      dataTestId="color-palette"
      className="color-palette"
      activeColor={activeColor}
      isMultiRow={isMultiRow}
    />
  );
};

export default memo(ColorPalette);
